export default __webpack_public_path__ + "static/media/icon_circle_money.bccbb045.svg";